













import Vue from 'vue'
import ProgressSpinner from '@/components/ProgressSpinner.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { ProgressSpinner },
    data: () => ({
        loading: true
    }),
    computed: {
        ...mapGetters(['xeroConnection', 'dataProviderSyncProgress'])
    },
    methods: {
        async xeroSync(): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Send the sync request to the API
            const response = await this.$store.dispatch('xeroSync')

            //  Stop the loading spinner
            this.loading = false

            //  If the response is 409, we hit the 'BlockIfSyncingMiddleware'
            if (response === 409) {
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Sync in progress',
                    icon: 'mdi-alert-circle-outline',
                    color: 'primary',
                    text: 'A sync is already in progress.  Data syncing can take a long time if you have a large data set. We appreciate your patience.'
                })
            } else {
                //  Activate sync progress
                this.$store.commit('dataProviderSyncProgressSet', {
                    message: 'Beginning Sync',
                    percent: 0,
                    model: 'Xero Data'
                })
            }
        }
    }
})
